import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { FormsModule } from '@angular/forms'
import { CustomerPageComponent } from './customer-page/customer-page.component'
import { SharedModule } from '../shared/shared.module'
import { DetailsToggleModule, DropdownModule } from '@inst-iot/bosch-angular-ui-components'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { RolloutsTileDataComponent } from './components/customer-layer-categories/rollouts-tile-data/rollouts-tile-data.component'
import { RolloutsTileSegmentDetailsComponent } from './components/rollouts-map-tile-segment-details/rollouts-map-tile-segment-details.component'
import { RolloutsTileMatchedSignsDetailsComponent } from './components/rollouts-map-tile-matched-signs-details/rollouts-map-tile-matched-signs-details.component'
import { CustomerDataLayerConfigComponent } from './components/customer-data-layer-config/customer-data-layer-config.component'
import { DetailsAccordionComponent } from '../shared/components/details/details-accordion/details-accordion'
import { CustomerLegendComponent } from './components/customer-legend/customer-legend.component'
import { CustomerHistoryControlComponent } from './components/customer-history-control/customer-history-control.component'
import { CustomerMapReportDialogComponent } from './components/customer-map-report-dialog/customer-map-report-dialog.component'
import { ReportingModeIndicatorComponent } from './components/reporting-mode-indicator/reporting-mode-indicator.component'
import { SignReportDialogComponent } from './components/sign-report-dialog/sign-report-dialog.component'

@NgModule({
  declarations: [
    CustomerPageComponent,
    RolloutsTileDataComponent,
    RolloutsTileSegmentDetailsComponent,
    RolloutsTileMatchedSignsDetailsComponent,
    CustomerDataLayerConfigComponent,
    CustomerLegendComponent,
    CustomerHistoryControlComponent,
    CustomerMapReportDialogComponent,
    ReportingModeIndicatorComponent,
    SignReportDialogComponent,
  ],
  imports: [
    CommonModule,
    DragDropModule,
    FormsModule,
    NgbTooltipModule,
    NgbDropdownModule,
    DetailsToggleModule,
    DropdownModule,
    SharedModule,
    NgbTooltipModule,
    DetailsAccordionComponent,
  ],
})
export class CustomerModule {}
